import FileHelper from './FileHelper';

export default class Document extends FileHelper {}
